module.exports = require("npm:async.util.isarray@0.5.2/index.js");